import { PublishedWithChanges, Sell } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import {
  FilterAccordionContainer,
  FilterCollapsibleList,
  FilterContainer,
  FilterFooter,
  FilterHeader,
} from '~/components/Filter';
import type { DesignList__FilterCount } from '../DesignList.generated';
import { useDesignFilters } from '../context';

interface FilterAccordionProps {
  filterCounts?: DesignList__FilterCount;
}

export const FilterAccordion = ({ filterCounts }: FilterAccordionProps) => {
  const { t } = useTranslation();
  const { filters, clearFilters, setFilter, toggleFilter } = useDesignFilters();
  const tagItems = filters.tags.items;
  const publishedItems = filters.published.items;

  return (
    <FilterContainer>
      <FilterHeader />
      <FilterAccordionContainer>
        <>
          {tagItems.length > 0 && (
            <FilterCollapsibleList
              Icon={Sell}
              expanded={filters.tags.open}
              items={tagItems.map((item) => {
                const matched = filterCounts?.tags.find((c) => c.filter === item.value);
                return { ...item, count: matched?.count || 0 };
              })}
              label={t('common.labels.tags')}
              loading={!filterCounts}
              onClick={(_, newItems) => setFilter({ field: 'tags', items: newItems })}
              onExpand={() => toggleFilter('tags')}
            />
          )}
          <FilterCollapsibleList
            Icon={PublishedWithChanges}
            expanded={filters.published.open}
            items={publishedItems.map((item) => {
              const matched = filterCounts?.published.find((c) => c.filter === String(item.value));
              return { ...item, count: matched?.count || 0 };
            })}
            label={t('pages.studio.filters.published')}
            loading={!filterCounts}
            onClick={(_, newItems) => setFilter({ field: 'published', items: newItems })}
            onExpand={() => toggleFilter('published')}
          />
        </>
      </FilterAccordionContainer>
      <FilterFooter handleClear={clearFilters} />
    </FilterContainer>
  );
};
